<template>
  <div>

    <header id="header">
      <router-link class="logo" :to="{ name: 'Start'}">
        <img src="/projects/hetfruit/templates/customerportal/images/logo.png" height="60">
      </router-link>
      <h3>Bedrijven bestelling</h3>
      <div>
        <router-link :to="{ name: 'CompanyOrders' }">
          <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32"><path fill="grey" d="M780-200v-156q0-60-39-99t-99-39H236l163 163-43 43-236-236 236-236 43 43-163 163h406q85 0 141.5 56.5T840-356v156h-60Z"/></svg>
        </router-link>
      </div>
    </header>

    <div class="content-container" v-if="data_is_fetched">

      <message-box v-if="page_is_edited_by_another_user" type="error">
        LET OP: deze bestelling wordt reeds door een andere gebruiker bewerkt
      </message-box>

      <form class="standard_order_form" method="post">
        <div class="form-section">

          <div class="section-header">
          <h3>{{ company_name }}
            <br>
            <span class="small">levering op {{ delivery_date }}</span>
          </h3>
            <div>
              <router-link class="btn" target="_blank"
                           :to="{ name: 'CrateLabel', params: { customername: company_name, date: delivery_date, city: company_city} }"
                           style="display: inline-flex; align-items: center; gap: 12px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                     class="bi bi-printer-fill" viewBox="0 0 16 16">
                  <path
                      d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                  <path
                      d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                </svg>
                <span>Sticker</span>
              </router-link>
            </div>
          </div>
        </div>

        <div class="form-section form-text-areas">
          <div class="form-label-text-area">
            <label>
              Opmerking klant:
            </label>
            <textarea id="remark" width="100%" v-model="remark"></textarea>
          </div>
          <div class="form-label-text-area">
            <label>
              Opmerking naar klant:
            </label>
            <textarea id="response_cust_remark" width="100%" v-model="response_cust_remark"></textarea>
          </div>
          <div class="form-label-text-area">
            <label>
              Interne opmerking:
            </label>
            <textarea id="internal_remark" cols="30" v-model="internal_remark" @input="internal_remark_changed = true"></textarea>
            <label v-if="internal_remark_changed">
              <input type="checkbox" value="1" name="copy_internal_remark" v-model="copy_internal_remark">
              Sla op in alle toekomstige bestellingen op deze leverdag
            </label>
          </div>
        </div>

          <h2 class="abo">{{abo}}</h2>
        <p class="abo_description" v-html="abo_description.replace(/\n/g, '<br>')"></p>

        <div class="form-section">
          <section>
            <div class="product_label" v-for="(crate_label, crate_key) in crates" :key="crate_key"
                 v-show="order_crates[crate_key].amount > 0" :class="{ checked: checked_crates[crate_key] }">
              <img src="/projects/hetfruit/templates/app/images/crate.png" class="product-icon" v-show="crate_key.includes('crate')">
              <img src="/projects/hetfruit/templates/app/images/tray.png" class="product-icon" v-show="crate_key.includes('bowl')">
              <img src="/projects/hetfruit/templates/app/images/bags.png" class="product-icon" v-show="crate_key.includes('bags')">
              <p class="product-text">{{ crate_label }} </p>

              <div class="product-input">
                <input-amount v-model:amount="order_crates[crate_key].amount"></input-amount>
              </div>

              <div class="product-check">
                <a @click="checked_crates[crate_key] = !checked_crates[crate_key]"
                   v-show="order_crates[crate_key].amount > 0">
                  <img :src="getCheckCrateIcon(crate_key)" height="40"/>
                </a>
              </div>
            </div>

            <div class="product_label" :class="{ checked: checked_fruit }">
              <img src="/projects/hetfruit/templates/app/images/fruit.svg" class="product-icon">
              <p class="product-text">Fruit</p>
              <p v-if="fruit_packages && fruit_packages > 1">
                {{ fruit_packages }} x {{ Math.round(fruit_amount / fruit_packages, 1) }}
              </p>
              <div class="product-input">
                <input-amount v-model:amount="fruit_amount"></input-amount>
              </div>

              <div class="product-check">
                <a @click="checked_fruit = !checked_fruit">
                  <img :src="getCheckedIcon(checked_fruit)" height="40"/>
                </a>
              </div>
            </div>


            <div class="product_label" :class="{ checked: checked_bananas }">
              <img src="/projects/hetfruit/templates/app/images/bananas.png" class="product-icon">
              <p class="product-text">Bananen</p>
              <p v-if="banana_packages && banana_packages > 1">
                {{ banana_packages }} x {{ Math.round(banana_amount / banana_packages, 1) }}
              </p>
              <div class="product-input">
                <input-amount v-model:amount="banana_amount"></input-amount>
              </div>
              <div class="product-check">
                <a @click="checked_bananas = !checked_bananas">
                  <img :src="getCheckedIcon(checked_bananas)" height="40"/>
                </a>
              </div>
            </div>

            <div class="product_label">
              <img src="/projects/hetfruit/templates/app/images/fruit.svg" class="product-icon">
              <p class="product-text">Totaal stuks fruit</p>
              <div class="product-input" style="font-size: 1.2rem; text-align: center; width: 126px;">
                {{ parseInt(fruit_amount) + parseInt(banana_amount) }}
              </div>
              <div class="product-check"></div>
            </div>

            <div v-if="order_vegetables" class="product_label" :class="{ checked: checked_vegetables }">
              <img src="/projects/hetfruit/templates/app/images/vegetables.svg" class="product-icon">
              <p class="product-text">Groenten</p>
              <div class="product-input">
                <input class="checkbox" type="checkbox" v-model="vegetables">
              </div>
              <div class="product-check">
                <a v-show="vegetables" @click="checked_vegetables = !checked_vegetables">
                  <img :src="getCheckedIcon(checked_vegetables)" height="40"/>
                </a>
              </div>
            </div>
          </section>

          <div class="product_label" v-for="product in products_with_amount" :key="product.id" :class="{ checked: checked_products[product.id] }">
            <img :src="product.image" class="product-icon">
            <p class="product-text">{{ product.name }}</p>

            <div class="product-input">
              <div style="display:inline-block;" v-if="product.has_weight_input">
                <input-amount v-model:amount="order_products[product.id].weight" placeholder="Gewicht"
                              :step="0.1" decimals="2"></input-amount>
                Kg
              </div>
            </div>
            <div class="product-input">
              <input-amount v-model:amount="order_products[product.id].amount"></input-amount>
            </div>
            <div class="product-price">
              {{
                displayPrice(order_products[product.id], product.price, product.has_weight_input)
              }}
            </div>

            <div class="product-check">
              <a @click="checked_products[product.id] = !checked_products[product.id]"
                 v-show="order_products[product.id].amount > 0">
                <img :src="getCheckProductIcon(product.id)" height="40"/>
              </a>
            </div>
          </div>
        </div>

        <message-box v-if="weight_error" type="error">
          <span>Bij één of meer producten is het gewicht nog niet ingevuld of afwijkend.</span>
          <br>
          <span v-for="message in weight_error_message" :key="message">
            {{message}}<br>
          </span>
        </message-box>

        <message-box v-if="checked_products_error" type="error">
          <span>Niet alle producten zijn aangevinkt. Is de bestelling compleet?</span>
        </message-box>

        <div style="display: flex; justify-content: space-between; margin-bottom: 40px;">
          <router-link class="btn btn-with-icon" :to="{ name: 'CompanyOrders' }">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path fill="grey" d="M780-200v-156q0-60-39-99t-99-39H236l163 163-43 43-236-236 236-236 43 43-163 163h406q85 0 141.5 56.5T840-356v156h-60Z"/></svg>
            Terug naar lijst</router-link>
          <a v-if="status ==='Geannuleerd'" class="btn warning" @click="activateCompanyOrder()">Reactiveer</a>
          <a v-else class="btn warning" @click="cancelCompanyOrder()">Annuleren</a>
          <a class="btn" @click="saveCompanyOrder(false)">Opslaan</a>
          <a class="btn" @click="saveCompanyOrder(true)">Opslaan en verwerkt</a>
        </div>

        <div class="form-section">
          <div class="section-header">
            <h3>Verpakking</h3>
            <a style="text-decoration: underline; cursor: pointer;"
               @click="show_all_packages = !show_all_packages">
              <span v-show="!show_all_packages">Toon alle</span>
              <span v-show="show_all_packages">Sluiten</span>
            </a>
          </div>

          <div class="product_label" v-for="(crate_label, crate_key) in crates" :key="crate_key"
               v-show="show_all_packages && order_crates[crate_key].amount == 0">
            <img src="/projects/hetfruit/templates/app/images/crate.png" class="product-icon"
                 v-show="crate_key.includes('crate')">
            <img src="/projects/hetfruit/templates/app/images/tray.png" class="product-icon"
                 v-show="crate_key.includes('bowl')">
            <img src="/projects/hetfruit/templates/app/images/bags.png" class="product-icon"
                 v-show="crate_key.includes('bags')">
            <p class="product-text">{{ crate_label }} </p>

            <div class="product-input">
              <input-amount v-model:amount="order_crates[crate_key].amount"></input-amount>
            </div>

            <div class="product-check">
              <a @click="checked_crates[crate_key] = !checked_crates[crate_key]"
                 v-show="order_crates[crate_key].amount > 0">
                <img :src="getCheckCrateIcon(crate_key)" height="40"/>
              </a>
            </div>
          </div>
        </div>

        <div v-for="category in categories_with_products" :key="category.category_id" class="form-section">
          <div class="section-header">
            <h3>{{ category.category_name }}</h3>
            <a style="text-decoration: underline; cursor: pointer;"
               @click="toggleShowAll(category.category_name)">
              <span v-show="!show_all_of_category.includes(category.category_name)">Toon alle</span>
              <span v-show="show_all_of_category.includes(category.category_name)">Sluiten</span>
            </a>
          </div>

          <div class="product_label" v-for="product in category.products" :key="product.id"
               v-show="show_all_of_category.includes(category.category_name) && order_products[product.id].amount <= 0">
            <img :src="product.image" class="product-icon">
            <p class="product-text">{{ product.name }}</p>

            <div class="product-input">
              <div style="display:inline-block;" v-if="product.has_weight_input">
                <input-amount v-model:amount="order_products[product.id].weight" placeholder="Gewicht"
                              :step="0.1" decimals="2"></input-amount>
                Kg
              </div>
            </div>
            <div class="product-input">
              <input-amount v-model:amount="order_products[product.id].amount"></input-amount>
            </div>
            <div class="product-price">
              {{
                displayPrice(order_products[product.id], product.price, product.has_weight_input)
              }}
            </div>

            <div class="product-check">
              <a @click="checked_products[product.id] = !checked_products[product.id]"
                 v-show="order_products[product.id].amount > 0">
                <img :src="getCheckProductIcon(product.id)" height="40"/>
              </a>
            </div>
          </div>
        </div>

      </form>


    </div>

  </div>
</template>

<script>

import ErrorHelper from "../helpers/ErrorHelper";
import InputAmount from '../components/InputAmount';
import {SimpleStore} from '../simplestore';
import MathHelper from "../helpers/MathHelper";
import MessageBox from "../components/MessageBox.vue";

export default {
  name: "CompanyOrder",
  components: {MessageBox, InputAmount},
  props: ['orderid'],
  data() {
    return {
      SimpleStore,
      id: 0,
      remark: '',
      response_cust_remark:'',
      internal_remark: '',
      internal_remark_changed: false,
      copy_internal_remark: false,
      banana_amount: 0,
      banana_packages: 0,
      fruit_amount: 0,
      fruit_packages: 0,
      vegetables: false,
      order_vegetables:true,
      delivery_date: '',
      status: '',
      crates_text: '',
      company_name: '',
      company_city: '',
      checked_fruit: false,
      checked_bananas: false,
      checked_vegetables: false,
      data_is_fetched: false,
      order_products: {}, // an object, because we want the product_id as keys
      categories_with_products: [],
      crates: {},
      checked_products: {}, // an object, because we want the product_id as keys
      order_crates: {}, // an object, because we want the product_id as keys
      checked_crates: {},
      weight_error: false,
      checked_products_error: false,
      show_all_packages: false,
      show_all_of_category: [],
      page_is_edited_by_another_user: false,
      max_kg:1.5,
      abo:"",
      abo_description:"",
      weight_error_message:[],
      is_inconto_order:false,
    };
  },
  mounted() {
    this.getCompanyProductsAndCrates();
    this.getPageBeingEdited();
  },

  watch: {
    // update the check_products array if order_products changes, we only want to show check marks for product with an amount > 0
    order_products() {
      let checked_products = {};
      for (let product_id in this.order_products) {
        if (this.order_products[product_id].amount <= 0) continue;
        if (Object.hasOwn(this.checked_products, product_id)) continue;
        checked_products[product_id] = false;
      }

      this.checked_products = checked_products;
    },

    // update the checked_crates array if order_crates changes, we only want to show check marks for crates with an amount > 0
    order_crates() {
      let checked_crates = {};
      for (let crate_type in this.order_crates) {
        if (this.order_crates[crate_type].amount <= 0) continue;
        if (Object.hasOwn(this.checked_crates, crate_type)) continue;
        checked_crates[crate_type] = false;
      }

      this.checked_crates = checked_crates;
    }
  },

  computed: {
    all_products() {
      let all_products = [];
      for (let key in this.categories_with_products) {
        all_products.push(...Array.from(this.categories_with_products[key].products));
      }
      return all_products;
    },

    // haal de product objecten uit de categorie boom op waarvan het aantal hoger is dan 0 (ingevuld dus)
    products_with_amount() {
      let products_with_amount = [];
      for (let category_key in this.categories_with_products) {
        for (let product_key in this.categories_with_products[category_key].products) {
          // aantal van product is 0
          if(this.order_products[this.categories_with_products[category_key].products[product_key].id].amount <= 0) continue;
          products_with_amount.push(this.categories_with_products[category_key].products[product_key]);
        }
      }

      return products_with_amount;
    }
  },

  methods: {

    getCompanyOrder() {
      fetch('?action=getCompanyOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          company_order_id: this.orderid,
        })
      }).then(res => res.json()).then((response) => {

        if (ErrorHelper.handleError(this, response)) return;

        this.id = response.data.id;
        this.remark = response.data.remark;
        this.internal_remark = response.data.internal_remark;
        this.response_cust_remark = response.data.response_cust_remark;
        this.banana_amount = response.data.banana_amount;
        this.banana_packages = response.data.banana_packages;
        this.fruit_amount = response.data.fruit_amount;
        this.fruit_packages = response.data.fruit_packages;
        this.vegetables = (response.data.vegetables === '1');
        this.order_vegetables = this.vegetables;
        this.delivery_date = response.data.delivery_date;
        this.status = response.data.status;
        this.abo = response.data.abo;
        this.abo_description = response.data.abo_description;
        this.is_inconto_order = response.data.is_inconto_order;

        this.crates_text = response.data.crates_text;
        this.company_name = response.data.company_name;
        this.company_city = response.data.company_city;

        for (let index in response.data.order_products) {
          // set the id as key, for easy access
          this.order_products[response.data.order_products[index].id] = response.data.order_products[index];
        }

        for (let index in response.data.order_crates) {
          // set the id as key, for easy access
          this.order_crates[response.data.order_crates[index].type] = response.data.order_crates[index];
        }
        this.setEmptyOrderProducts();
        this.setEmptyOrderCrates();

        this.data_is_fetched = true;

        this.$nextTick(() => {
          document.getElementById('remark').style.height = 'auto'; // Stel eerst de hoogte in op auto om te voorkomen dat de scrollbars verschijnen
          // Stel de hoogte van de textarea in op de scrollhoogte van de inhoud
          document.getElementById('remark').style.height = document.getElementById('remark').scrollHeight + 'px';
          document.getElementById('internal_remark').style.height = 'auto'; // Stel eerst de hoogte in op auto om te voorkomen dat de scrollbars verschijnen
          // Stel de hoogte van de textarea in op de scrollhoogte van de inhoud
          document.getElementById('internal_remark').style.height = document.getElementById('response_cust_remark').scrollHeight + 'px';
          document.getElementById('response_cust_remark').style.height = 'auto';
          document.getElementById('response_cust_remark').style.height = document.getElementById('response_cust_remark').scrollHeight + 'px';
        });
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
        this.data_is_fetched = true;
      });
    },

    getCompanyProductsAndCrates() {
      fetch('?action=getCompanyproductsandcrates', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",
        },
        body: JSON.stringify({
          company_order_id: this.orderid,
        }),
      }).then(res => res.json()).then((response) => {

        if (ErrorHelper.handleError(this, response)) return;

        this.categories_with_products = response.data.products;
        this.crates = response.data.crates;

        this.getCompanyOrder();
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },

    saveCompanyOrder(is_processed) {
      // validate weight first
      this.weight_error = false;
      this.weight_error_message = [];

      for (let product_id in this.order_products) {
        // not all products have weight input
        let product = this.all_products.find((element) => element.id == product_id);
        if (product?.has_weight_input !== true) continue;
        // we dont have to insert the weight for products with no amount
        if (!this.order_products[product_id].amount || parseInt(this.order_products[product_id].amount) <= 0) continue;
        if (!this.order_products[product_id].weight || parseFloat(this.order_products[product_id].weight) <= 0 || parseFloat(this.order_products[product_id].weight)>parseFloat(this.order_products[product_id].amount * this.max_kg )) {
          this.weight_error_message.push("Controleer product: "+ product.name);
        }
      }

      if (this.weight_error_message.length>0) {
        this.weight_error = true;
        return;
      }

      // valideer of alle vinkjes gezet zijn
      this.checked_products_error = false;
      if( (this.fruit_amount>0 && this.checked_fruit == false) ||
          (this.vegetables && this.checked_vegetables == false) ||
          (this.banana_amount > 0 && this.checked_bananas == false)
      ) {
        this.checked_products_error = true;
        return;
      }
      // we checken of een product ook in all_products zit, het is namelijk zo dat een product verhuist kan zijn, maar dat het nog wel in de database gekoppeld is aan de bestelling
      // eigenlijk klopt dit niet, maar hier vangen we dit wel af
      const all_product_ids = this.all_products.map((product) => product.id);
      const active_products = Object.values(this.order_products).filter((product) => product.amount > 0 && all_product_ids.includes(product.id)).length;
      if(active_products > Object.keys(this.checked_products).length) {
        this.checked_products_error = true;
        return;
      }

      fetch('?action=saveCompanyOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          company_order_id: this.orderid,
          remark: this.remark,
          internal_remark: this.internal_remark,
          copy_internal_remark: this.copy_internal_remark,
          response_cust_remark: this.response_cust_remark,
          banana_amount: this.banana_amount,
          fruit_amount: this.fruit_amount,
          vegetables: this.vegetables,
          is_processed: is_processed,
          order_products: this.order_products,
          order_crates: this.order_crates
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$router.push({name: 'CompanyOrders'});
          return;
        }
        SimpleStore.addFlashMessage(response.message, 'success');
        this.$router.push({name: 'CompanyOrders'});
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    cancelCompanyOrder() {
      fetch('?action=cancelCompanyOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          company_order_id: this.orderid,
          remark: this.remark,
          response_cust_remark: this.response_cust_remark,
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$router.push({name: 'CompanyOrders'});
          return;
        }

        SimpleStore.addFlashMessage(response.message, 'success');
        this.$router.push({name: 'CompanyOrders'});
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    activateCompanyOrder() {
      fetch('?action=activateCompanyOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          company_order_id: this.orderid,
          remark: this.remark,
          response_cust_remark: this.response_cust_remark,
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$router.push({name: 'CompanyOrders'});
          return;
        }

        SimpleStore.addFlashMessage(response.message, 'success');
        this.$router.push({name: 'CompanyOrders'});
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    // we want an array with all the products, not only the ordered products
    setEmptyOrderProducts() {
      // create a product with amount 0, if it does not exist (not ordered)
      for (let index in this.all_products) {
        if (Object.hasOwn(this.order_products, this.all_products[index].id)) continue;
        this.order_products[this.all_products[index].id] = {
          id: this.all_products[index].id,
          amount: 0,
        };
      }

      this.data_is_fetched = true;
    },

    // we want an array with all the crates, not only the order crates
    setEmptyOrderCrates() {
      // create a crate with amount 0, if it does not exist
      for (let crate_key in this.crates) {
        if (Object.hasOwn(this.order_crates, crate_key)) continue;
        this.order_crates[crate_key] = {
          type: crate_key,
          amount: 0,
          name: this.crates[crate_key].name
        };
      }

      this.data_is_fetched = true;
    },

    getCheckedIcon(boolean) {
      if (boolean) {
        return '/projects/hetfruit/templates/app/images/check_active.svg';
      }
      return '/projects/hetfruit/templates/app/images/check_not_active.svg';
    },

    getCheckCrateIcon(crate_key) {
      if (this.checked_crates[crate_key] === true) {
        return '/projects/hetfruit/templates/app/images/check_active.svg';
      }
      return '/projects/hetfruit/templates/app/images/check_not_active.svg';
    },

    getCheckProductIcon(product_id) {
      if (this.checked_products[product_id] === true) {
        return '/projects/hetfruit/templates/app/images/check_active.svg';
      }
      return '/projects/hetfruit/templates/app/images/check_not_active.svg';
    },

    displayPrice(product, price, has_weight_input) {
      if (has_weight_input) {
        let product_weight = product.weight;
        if (isNaN(parseFloat(product.weight))) {
          product_weight = 0;
        }
        return '€ ' + MathHelper.currencyFormat((parseFloat(product_weight) * parseFloat(price)), 2);
      }
      else {
        return '€ ' + MathHelper.currencyFormat((parseFloat(product.amount) * parseFloat(price)), 2);
      }
    },

    toggleShowAll(category_name) {
      const category_index = this.show_all_of_category.findIndex(category => category == category_name);
      // add
      if(category_index === -1) this.show_all_of_category.push(category_name)
      // remove
      else this.show_all_of_category.splice(category_index, 1);
    },

    getPageBeingEdited() {
      fetch('?action=getPageBeingEdited&page=company_order&order_id=' + this.orderid, {
        method: "GET",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
      }).then(res => res.json()).then((response) => {
        this.page_is_edited_by_another_user = response.data;
      });
    },

  },
}

</script>

<style scoped>
.toolbar {
  display: none;
}

.product_label.checked {
  background: hsla(73, 87%, 45%, 8%);
}

h2.abo{
  margin-top: 1em;
}

.abo_description{
  font-style: italic;
  border: 1px solid #333;
  background-color: rgb(149, 191, 13);
  border-radius: 0.2em;
  color: #000;
  padding: 1em;
  margin-bottom: 1.5em;
}
.btn.warning{
  background-color: #D10017FF;
  border-color: #D10017FF;
  color: white;
}
</style>
